import { useId, type TextareaHTMLAttributes } from 'react'

import estilos from './Formulario.module.css'

type PropsAreaTexto = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'id'> & {
  etiqueta: string
  ayuda?: string
  error?: string
  obligatorio?: boolean
}

/**
 * Área de texto para las justificaciones.
 *
 * Es el campo de las compuertas: la base rechaza una aprobación, un rechazo o
 * una solicitud de más tiempo que llegue sin motivo escrito.
 */
export function AreaTexto({
  etiqueta,
  ayuda,
  error,
  obligatorio = false,
  className,
  ...resto
}: PropsAreaTexto) {
  const id = useId()
  const idAyuda = `${id}-ayuda`

  const clases = [
    estilos.control,
    estilos.area,
    error ? estilos.conError : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={estilos.campo}>
      <label className={estilos.etiqueta} htmlFor={id}>
        {etiqueta}
        {obligatorio && (
          <span className={estilos.obligatorio} aria-hidden="true">
            *
          </span>
        )}
      </label>

      <textarea
        id={id}
        className={clases}
        required={obligatorio}
        aria-invalid={Boolean(error)}
        aria-describedby={error || ayuda ? idAyuda : undefined}
        {...resto}
      />

      {error ? (
        <span id={idAyuda} className={estilos.error}>
          {error}
        </span>
      ) : (
        ayuda && (
          <span id={idAyuda} className={estilos.ayuda}>
            {ayuda}
          </span>
        )
      )}
    </div>
  )
}
